import {IS_EMAIL} from "./regex.mjs";

export default mail=>IS_EMAIL.test(mail);
